<template>
  <div class="card mb-4">
    <h5 class="card-header">Attachments</h5>
    <div class="card-body">
      <AttachmentsList :entity-id="carrier.id" entity-type="carrier" />
    </div>
  </div>
</template>

<script>
import AttachmentsList from '@/components/shared/AttachmentsList';

export default {
  name: 'CarrierAttachments',
  components: { AttachmentsList },
  props: {
    carrier: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
